import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import Home from "ui/organizms/Home";

const HomeScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Home'
    >
        <Home />
    </Screen>
);

export default memo(HomeScreen);
